module.exports = __webpack_public_path__ + "media/images/lb/792-cf39afbc408c89738516f65ea7619682.svg";